import { useCallback, useEffect, useState } from 'react';
import { checkEditRestrictedOffMarket } from './utils';
import { RestrictionType } from './types';
import { Permissions } from '../../../../system/permission';
import { PropertyField } from '../../../../system/field';
import { useAuth } from '../../../../contexts/AuthContext';

export const useListingRestrictions = () => {
  const { allowed } = useAuth();
  const [listingData, setListingData] = useState<any>(null);
  const [restrictionEdit, setRestrictionEdit] = useState<RestrictionType>(
    RestrictionType.NONE,
  );

  const isEditRestricted = useCallback(
    (restrictionType?: RestrictionType) => {
      if (restrictionEdit === restrictionType) {
        return true;
      }

      return !restrictionType
        ? restrictionEdit === RestrictionType.DENIED ||
            restrictionEdit === RestrictionType.WARNING
        : false;
    },
    [restrictionEdit],
  );

  const canMakeDataCorrections = () => {
    return allowed({
      permission: Permissions.DATA_CORRECTIONS,
    });
  };

  useEffect(() => {
    // Exit if no listing data
    if (!listingData) {
      setRestrictionEdit(RestrictionType.NONE);
      return;
    }

    const property = listingData.Property;
    const listingStatus =
      property[PropertyField.STANDARD_STATUS] ||
      property[PropertyField.MLS_STATUS];
    const baseOffMarketDate = property[PropertyField.BASE_OFF_MARKET_DATE];

    // Check for restriction and update state
    const isRestrictedOffMarket = checkEditRestrictedOffMarket(
      listingStatus,
      baseOffMarketDate,
    );

    if (isRestrictedOffMarket) {
      const restriction = canMakeDataCorrections()
        ? RestrictionType.WARNING
        : RestrictionType.DENIED;
      setRestrictionEdit(restriction);
    } else {
      setRestrictionEdit(RestrictionType.NONE);
    }
  }, [listingData, setRestrictionEdit]);

  return {
    setListing: setListingData,
    isEditRestricted,
  };
};
